export const CONSTANTS = {
  PAGE_NOT_FOUND: 'ページが見つかりません',
  CHECK_URL:
    'リクエストしたページは存在しません。 URL を確認して、もう一度お試しください。',
  TO_LOGIN_PAGE: 'ログインページへ',
};
